import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import mainLayout from '@/views/layout/mainLayout.vue'
import Dashboard from '@/views/Dashboard.vue'
import UserList from '@/views/UserList.vue'
import BannerList from '@/views/BannerList.vue'
import FAQs from '@/views/FAQs.vue'
import store from '@/store'
import TrackCode from '@/views/TrackCode.vue'
import Worker from '@/views/WorkerView.vue'
import Message from '@/views/MessageView.vue'
import MessageHistory from '@/views/MessageHistory.vue'
import ReportList from '@/views/ReportList.vue'
import ReportView from '@/views/ReportView.vue'
import ReportDashboard from '@/views/ReportDashboard.vue'
import CostList from '@/views/CostList.vue'
import CostTypeList from '@/views/CostTypeList.vue'

const routes = [{
  path: '/',
  component: mainLayout,
  redirect: '/configs',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '/configs',
    name: 'configs',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/users',
    name: 'users',
    component: UserList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/message',
    name: 'message',
    component: Message,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/banners',
    name: 'banners',
    component: BannerList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/faqs',
    name: 'faqs',
    component: FAQs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/trackCodes',
    name: 'trackCodes',
    component: TrackCode,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/worker',
    name: 'worker',
    component: Worker,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/messageHistory',
    name: 'messageHistory',
    component: MessageHistory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports',
    name: 'reports',
    component: ReportList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/dashboard',
    name: 'reportDashboard',
    component: ReportDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/:id',
    name: 'reportView',
    component: ReportView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/costs',
    name: 'costs',
    component: CostList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/costs/transfer',
    name: 'costsTransfer',
    component: CostList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/costs/deliveries',
    name: 'costsDeliveries',
    component: CostList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/costs/:typeId',
    name: 'costsByType',
    component: CostList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/costTypes',
    name: 'costTypes',
    component: CostTypeList,
    meta: {
      requiresAuth: true
    }
  }
  ]
}, {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    requiresAuth: false
  }
},
{
  path: '/register',
  name: 'Register',
  component: Register,
  meta: {
    requiresAuth: false
  }
},
{
  path: '/login',
  name: 'AuthError',
  component: Login,
  meta: {
    requiresAuth: false
  }
}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth // Маршрут authentication шаардах эсэхийг шалгах
  const token = store.state.token // Хэрэглэгчийн authentication токен
  const user = store.state.user // Хэрэглэгчийн мэдээлэл

  if (requiresAuth && !token) {
    // Authentication шаардлагатай боловч токен байхгүй үед Login руу шилжүүлэх
    next({ name: 'Login' })
  } else if (!requiresAuth) {
    // Authentication шаардлагагүй бол шууд үргэлжлүүлэх
    next()
  } else {
    // Authentication шаардлагатай бөгөөд токен байгаа тохиолдолд хэрэглэгчийн мэдээллийг шалгах
    if (user) {
      if (user.lastName) {
        // Хэрэглэгчийн lastName байвал үргэлжлүүлэх
        next()
      } else {
        // lastName байхгүй бол AuthError руу шилжүүлэх
        next({ name: 'AuthError' })
      }
    } else {
      // Хэрэглэгчийн мэдээлэл байхгүй бол үргэлжлүүлэх
      next()
    }
  }
})

export default router
